import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { StepServiceModel } from '../../models/consult/step-service.model';


export class GetStepServiceUseCase implements UseCase<{ IdService: string}, StepServiceModel> {
    constructor(private ConsultRepository: ConsultRepository) { }
    execute(
        params: {IdService: string},
    ): Observable<StepServiceModel> {
        return this.ConsultRepository.getStepService(params);
    }
}
